import { Box } from '@mantine/core';

import { useGetColor } from 'hooks';

import type { IconPropsType } from './types';

export const DocumentPackageIcon = ({
  color,
  size = 24,
  sx,
  ...props
}: IconPropsType) => {
  const iconColor = useGetColor(color);

  return (
    <Box
      component="svg"
      sx={sx}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.0714 13.4948H16.9285M10.0714 16.9286H16.9285M10.0714 10.0684H16.9285M13.9285 2.5H4.78568C4.1545 2.5 3.64282 3.01168 3.64282 3.64286V17.3571C3.64282 17.9883 4.1545 18.5 4.78568 18.5M19.2143 21.5H7.78568C7.1545 21.5 6.64282 20.9883 6.64282 20.3571V6.64286C6.64282 6.01168 7.1545 5.5 7.78568 5.5H16.9285L20.3571 8.92857V20.3571C20.3571 20.9883 19.8454 21.5 19.2143 21.5Z"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </Box>
  );
};
